import { Section } from "./Section";

import { Text } from "~/components/Text";
import type { AppointmentDetails } from "~/utils/appointment.utils.server";
import { getFullName } from "~/utils/getFullName";

interface CustomerSectionProps {
  customer: AppointmentDetails["customer"];
}

export function CustomerSection({ customer }: CustomerSectionProps) {
  return (
    <Section
      data-variant="CustomerSection"
      title={<Text i18nKey="Confirmation.personal_details" />}
      data-sentry-mask
    >
      <Section.Item
        title={getFullName({ firstName: customer.first_name, lastName: customer.last_name })}
      >
        <ul>
          {customer.customer_number && <li>{customer.customer_number}</li>}
          {customer.email && <li>{customer.email}</li>}
          {customer.phone_number && <li>{customer.phone_number}</li>}
        </ul>
      </Section.Item>

      {customer.location && (
        <Section.Item>
          <ul>
            <li>{customer.location.street_1}</li>
            <li>
              {customer.location.postal_code} {customer.location.city}
            </li>
            {customer.location.state && <li>{customer.location.state}</li>}
            <li>{customer.location.country}</li>
          </ul>
        </Section.Item>
      )}
    </Section>
  );
}
